
export default {
  paymentDetails: "Payment Details",
  totalCampaignCost: "Total Campaign Cost",
  termsAndConditions: "Terms and Conditions",
  acceptTerms: "I agree to the terms and conditions",
  campaignSubmitted: "Campaign Submitted",
  campaignSubmittedDesc: "Thank you! Your campaign has been submitted successfully. It will be processed shortly.",
  totalAmount: "Total Amount",
  bankTransfer: "Bank Transfer",
  creditCard: "Credit Card",
  iban: "IBAN",
  bankName: "Bank Name",
  emailAddress: "Email Address",
  bankTransferInstructions: "Please transfer the amount to the bank account below and send us an email with the receipt. Your campaign will start after payment confirmation.",
  processing: "Processing...",
  saveAndStartCampaign: "Save & Start Campaign",
  campaignCreated: "Campaign created successfully!",
  payNow: "Pay Now",
  payLater: "Pay Later",
  
  // Updated translations
  completePayment: "Complete Payment",
  choosePaymentMethod: "Choose your Payment Method",
  
  // New translations
  campaignSubmittedTitle: "Campaign Created Successfully!",
  campaignSubmittedDescription: "Your campaign has been successfully submitted and is now under review by our team.",
  campaignViewInstructions: "Access insights and analytics for your campaign in your exclusive client dashboard",
  visitClientPortal: "Access Dashboard",
  closeAndStayHere: "Create Another Campaign",
  
  // Validation messages
  campaignValidationFailed: "Please complete all previous steps before proceeding to payment.",
  
  // Quotation System
  invoice: "Quotation",
  invoiceNumber: "Quotation Number",
  invoiceDate: "Date",
  downloadInvoice: "Download Quotation",
  viewInvoice: "View Quotation",
  invoiceStatus: "Status",
  invoicePaid: "Paid",
  invoicePending: "Pending",
  invoiceDetails: "Quotation Details",
  billingDetails: "Customer Details",
  paymentMethodDetails: "Payment Method Details",
  paymentMethod: "Payment Method",
  paymentDate: "Date",
  paymentTotal: "Total Amount",
  vatIncluded: "VAT Included",
  close: "Close",
  loading: "Loading document...",
  
  // Tax Invoice System
  taxInvoice: "Tax Invoice",
  taxInvoiceForm: "Tax Invoice Details",
  taxInvoicePreview: "Invoice Preview",
  generateTaxInvoice: "Generate Invoice",
  invoiceGenerated: "Invoice generated successfully",
  invoiceGenerating: "Generating invoice...",
  vatNumber: "VAT Registration Number",
  companyAddress: "Company Address",
  city: "City",
  postalCode: "Postal Code",
  commercialRegistration: "Commercial Registration",
  pricePerDay: "Price Per Day",
  amountPaid: "Amount Paid",
  remainingBalance: "Remaining Balance",
  subtotal: "Subtotal",
  netTotal: "Net Total",
  seller: "Seller",
  buyer: "Buyer",
  requiredBillingInfo: "Required Billing Information",
  addressRequired: "Address is required",
  cityRequired: "City is required",
  postalCodeRequired: "Postal code is required",
  vatNumberRequired: "VAT number is required",
  invalidVatNumber: "Invalid VAT number (must be 15 digits starting with 3)",
  confirmAndProceed: "Confirm & Proceed",
} as const;
